<template>
  <!-- min-h-screen, not h-screen: the register form is taller than a short
       viewport and was being clipped rather than allowed to scroll. -->
  <div
    class="min-h-screen w-full flex flex-col bg-scoped-gradient font-primary"
  >
    <!-- main content -->
    <div ref="contentContainer" class="flex w-full flex-1 overflow-x-hidden">
      <router-view class="w-full" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Unauthenticated",
};
</script>
